import { ResponsibleBanner, useScreenQuery } from 'playup-web-core';
import ReusableModalPlain from '../ReusableModal/ReusableModalPlain';
import styled from 'styled-components';
import React, { useContext } from 'react';
import playupLogo from './logo.png';
import DSLogo from './logo-header.png';
import RSGBG from './RSGBg.png';
import GlobalContext from '../../contexts/GlobalContext';
import { useHistory } from 'react-router-dom';
const RGSModal = ({ onClose }: { onClose: () => void }) => {
	const { isSmall } = useScreenQuery();
	const width = isSmall ? window.innerWidth : 555;
	const imageWidth = width * 0.8;
	const { onResponse } = useContext(GlobalContext);
	const history = useHistory();
	return (
		<StyledModal $isSmall={isSmall} $width={isSmall ? '100%' : '555px'} $alignTop={false}>
			<div className=" _flex _justify-center _items-center _flex-col _flex-1 _p-4">
				<div
					style={{
						marginBottom: 10,
						flexDirection: 'row',
						alignItems: 'center',
						justifyContent: 'center',
						display: 'flex',
					}}
				>
					<img
						style={{
							width: width * 0.2,
							height: ((width * 0.2) / 600) * 200,
						}}
						src={playupLogo}
					/>
					<PlusText>+</PlusText>
					<img
						style={{
							width: width * 0.3,
							height: ((width * 0.3) / 399) * 65,
						}}
						src={DSLogo}
					/>
				</div>
				<RGText>R E S P O N S I B L E {'   '}G A M B L I N G</RGText>
				<img
					src={RSGBG}
					style={{
						width: imageWidth * 0.7,
						height: (imageWidth / 1092) * 0.7 * 771,
					}}
				/>
				<span className={`  _text-xl _font-bold _text-center _break-words  ${isSmall && '_whitespace-pre-wrap'} `}>
					Are you gambling {'\n'} within your limits?
				</span>
				<span className=" _text-gray-400 _text-sm _font-medium  _mt-1 _mb-8 _text-center">
					Take a moment to ensure your gambling stays under your control and remains an enjoyable source of
					entertainment.
				</span>
				<StyledButton
					onClick={() => {
						history.push('/account/limits');
						onResponse(1);
					}}
				>
					Set a Deposit Limit
				</StyledButton>
				<StyledButton
					outlined
					onClick={() => {
						history.push('/account/take-a-break');
						onResponse(2);
					}}
				>
					Take a Break
				</StyledButton>
				<span
					onClick={() => {
						onResponse(3);
						onClose();
					}}
					className=" _font-bold _text-lg _underline _mb-5  _text-gray-400 _cursor-pointer"
				>
					No Thanks
				</span>
			</div>
			<ResponsibleBanner textCenter />
		</StyledModal>
	);
};
const PlusText = styled.span({
	fontStyle: 'italic',
	fontWeight: '600',
	fontSize: 30,
	marginBottom: 5,
	marginLeft: 5,
	marginRight: 5,
});
const RGText = styled.span({
	fontSize: 14,
	fontWeight: 'bold',
	textAlign: 'center',
	marginBottom: 20,
});
const StyledButton = styled.button<{
	outlined?: boolean;
}>(({ outlined }) => ({
	borderWidth: 1,
	borderColor: '#FFFFFF',
	backgroundColor: outlined ? 'transparent' : '#FFFFFF',
	color: outlined ? '#FFFFFF' : '#000000',
	borderRadius: 24,
	minWidth: 256,
	paddingTop: 8,
	paddingBottom: 8,
	marginBottom: 20,
	fontWeight: 'bold',
}));
const StyledModal = styled(ReusableModalPlain)<{ $alignTop?: boolean; $width?: string; $isSmall?: boolean }>`
	display: flex;
	flex-direction: column;
	width: ${({ $width = '416px' }) => $width};
	min-height: ${({ $isSmall }) => ($isSmall ? '100vh' : '350px')};
	max-height: ${(props) => (props.$isSmall ? '100vh' : '80vh')};
	${({ $alignTop }) => ($alignTop ? 'margin-top: 5%;' : '')}
	background-color: #22272E;
	overflow-y: scroll;
`;
export default RGSModal;
